// import MailchimpSubscribe from "react-mailchimp-subscribe";
// import { Newsletter } from "./Newsletter";

// export const MailchimpForm = () => {
//   const postUrl = `${process.env.REACT_APP_MAILCHIMP_URL}?u=${process.env.REACT_APP_MAILCHIMP_U}&id=${process.env.REACT_APP_MAILCHIMP_ID}`;

//   return (
//     <>
//       <MailchimpSubscribe
//         url={postUrl}
//         render={({ subscribe, status, message }) => (
//           <Newsletter
//             status={status}
//             message={message}
//             onValidated={formData => subscribe(formData)}
//             />
//         )}
//         />
//     </>
//   )
// }


import MailchimpSubscribe from "react-mailchimp-subscribe";
import { Newsletter } from "./Newsletter";

export const MailchimpForm = () => {

  const mailchimpUrl = process.env.REACT_APP_MAILCHIMP_URL;
  const mailchimpU = process.env.REACT_APP_MAILCHIMP_U;
  const mailchimpId = process.env.REACT_APP_MAILCHIMP_ID;

  const postUrl = `${process.env.REACT_APP_MAILCHIMP_URL}?u=${process.env.REACT_APP_MAILCHIMP_U}&id=${process.env.REACT_APP_MAILCHIMP_ID}`;
   
  // ✅ Console logs for debugging
  console.log("MAILCHIMP_URL:", mailchimpUrl);
  console.log("MAILCHIMP_U:", mailchimpU);
  console.log("MAILCHIMP_ID:", mailchimpId);
  console.log("POST_URL:", postUrl);
  
  return (
    <MailchimpSubscribe
      url={postUrl}
      render={({ subscribe, status, message }) => (
        <Newsletter
          status={status}
          message={message}
          onValidated={(formData) => subscribe(formData)}
        />
      )}
    />
  );
};
